"use client";

import * as React from "react";
import { ShortcutRegistry, type Shortcut } from "./shortcut-registry";

const RegistryContext = React.createContext<ShortcutRegistry | null>(null);

export function KeyboardProvider({ children }: { children: React.ReactNode }) {
  const [registry] = React.useState(() => new ShortcutRegistry());
  return <RegistryContext.Provider value={registry}>{children}</RegistryContext.Provider>;
}

export function useShortcutRegistry(): ShortcutRegistry {
  const r = React.useContext(RegistryContext);
  if (!r) throw new Error("useShortcutRegistry must be used inside <KeyboardProvider>");
  return r;
}

/** Register a shortcut for the lifetime of the calling component. */
export function useRegisterShortcut(s: Shortcut): void {
  const registry = useShortcutRegistry();
  React.useEffect(() => {
    registry.register(s);
    return () => registry.unregister(s.id);
  }, [registry, s.id, s.keys, s.scope, s.label, s.sensitive]);
}
